import __request__ from "routing/request";
export function overview(requestOptions) {
  return __request__("GET", "/api-docs", null, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function globalOverview(requestOptions) {
  return __request__("GET", "/api-docs/global", null, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function route(route2, requestOptions) {
  return __request__("GET", `/api-docs/${route2}`, null, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
